export const CHO_FDC_NUTRIENT_ID = 1005;
export const PRO_FDC_NUTRIENT_ID = 1003;
export const FAT_FDC_NUTRIENT_ID = 1004;
export const ENERGY_FDC_NUTRIENT_ID = 1008;
export const MACRO_FDC_NUTRIENT_IDS = [CHO_FDC_NUTRIENT_ID, PRO_FDC_NUTRIENT_ID, FAT_FDC_NUTRIENT_ID, ENERGY_FDC_NUTRIENT_ID];
export const APP_KEY_TO_MACRO_FDC_NUTRIENT_ID_MAP = {
    kcal: ENERGY_FDC_NUTRIENT_ID,
    cho: CHO_FDC_NUTRIENT_ID,
    pro: PRO_FDC_NUTRIENT_ID,
    fat: FAT_FDC_NUTRIENT_ID,
};
export const caloriesFromMacros = (macros) => {
    return macros.cho * 4 + macros.pro * 4 + macros.fat * 9;
};
export const lipids = [
    "Fat",
    "Monounsaturated Fat",
    "Polyunsaturated Fat",
    "Saturated Fat",
    "Trans Fat",
    "Cholesterol",
    "EPA",
    "DPA",
    "DHA",
    "ALA",
    "Linoleic Acid",
];
export const minerals = [
    "Calcium",
    "Iron",
    "Magnesium",
    "Phosphorus",
    "Potassium",
    "Sodium",
    "Zinc",
    "Copper",
    "Manganese",
    "Selenium",
];
export const carbs = ["Total Carbs", "Fiber", "Total Sugars", "Starch", "Added Sugars"];
export const proteins = [
    "Protein",
    "Histidine",
    "Isoleucine",
    "Leucine",
    "Methionine",
    "Phenylalanine",
    "Threonine",
    "Tryptophan",
    "Valine",
    "Lysine",
    // Non-essential
    "Cystine",
    "Tyrosine",
    "Arginine",
    "Alanine",
    "Glutamate",
    "Glutamine",
    "Aspartic Acid",
    "Glycine",
    "Proline",
    "Serine",
];
export const vitamins = [
    "Vitamin A",
    "Vitamin E",
    "Vitamin D",
    "Vitamin C",
    "Thiamin",
    "Riboflavin",
    "Niacin",
    "Pantothenic Acid",
    "Vitamin B6",
    "Biotin",
    "Vitamin B12",
    "Choline",
    "Vitamin K",
    "Folate",
];
export const other = ["Alcohol", "Caffeine", "Choline", "Water"];
export const usdaNameToUnit = (nutrientName) => {
    switch (nutrientName) {
        // Macros & Carbs (g)
        case "Total lipid (fat)":
        case "Fatty acids, total saturated":
        case "Fatty acids, total trans":
        case "Fatty acids, total monounsaturated":
        case "Fatty acids, total polyunsaturated":
        case "Carbohydrate, by difference":
        case "Sugars, added":
        case "Fiber, total dietary":
        case "Sugars, total including NLEA":
        case "Starch":
        case "Protein":
        // Fatty acid subtypes (g)
        case "18:3 n-3 c,c,c (ALA)":
        case "20:5 n-3 (EPA)":
        case "22:5 n-3 (DPA)":
        case "22:6 n-3 (DHA)":
        case "18:2 n-6 c,c":
        // Amino acids (g)
        case "Histidine":
        case "Isoleucine":
        case "Leucine":
        case "Lysine":
        case "Methionine":
        case "Phenylalanine":
        case "Threonine":
        case "Tryptophan":
        case "Valine":
        case "Alanine":
        case "Arginine":
        case "Aspartic acid":
        case "Cystine":
        case "Glutamic acid":
        case "Glutamine":
        case "Glycine":
        case "Proline":
        case "Serine":
        case "Tyrosine":
        // Other (g)
        case "Alcohol, ethyl":
        case "Water":
            return "g";
        // Minerals (mg)
        case "Calcium, Ca":
        case "Iron, Fe":
        case "Potassium, K":
        case "Sodium, Na":
        case "Cholesterol":
        case "Magnesium, Mg":
        case "Phosphorus, P":
        case "Zinc, Zn":
        case "Copper, Cu":
        case "Manganese, Mn":
        // Vitamins (mg)
        case "Vitamin E (alpha-tocopherol)":
        case "Vitamin C, total ascorbic acid":
        case "Thiamin":
        case "Riboflavin":
        case "Niacin":
        case "Vitamin B-6":
        case "Pantothenic acid":
        case "Choline, total":
        // Other (mg)
        case "Caffeine":
            return "mg";
        // Vitamins & Minerals (mcg)
        case "Vitamin D (D2 + D3), International Units":
        case "Vitamin A, RAE":
        case "Vitamin B-12":
        case "Folate, DFE":
        case "Vitamin K (phylloquinone)":
        case "Biotin":
        case "Selenium, Se":
            return "mcg";
        default:
            return null;
    }
};
export const usdaNameToCommonName = (nutrientName) => {
    switch (nutrientName) {
        // Lipids
        case "Total lipid (fat)":
            return "Fat";
        case "Fatty acids, total monounsaturated":
            return "Monounsaturated Fat";
        case "Fatty acids, total polyunsaturated":
            return "Polyunsaturated Fat";
        case "Fatty acids, total saturated":
            return "Saturated Fat";
        case "Fatty acids, total trans":
            return "Trans Fat";
        case "Cholesterol":
            return "Cholesterol";
        case "18:3 n-3 c,c,c (ALA)":
            return "ALA";
        case "18:2 n-6 c,c":
            return "Linoleic Acid";
        case "20:5 n-3 (EPA)":
            return "EPA";
        case "22:5 n-3 (DPA)":
            return "DPA";
        case "22:6 n-3 (DHA)":
            return "DHA";
        //Carbs
        case "Carbohydrate, by difference":
            //case "Carbohydrate, by summation":
            return "Total Carbs";
        case "Sugars, added":
            return "Added Sugars";
        case "Starch":
            return "Starch";
        case "Fiber, total dietary":
            return "Fiber";
        //case "Sugars, Total NLEA":
        case "Sugars, total including NLEA":
            return "Total Sugars";
        //Protein
        case "Protein":
            return "Protein";
        case "Aspartic acid":
            return "Aspartic Acid";
        case "Glutamic acid":
            return "Glutamate";
        case "Arginine":
        case "Alanine":
        case "Glutamine":
        case "Glycine":
        case "Proline":
        case "Serine":
        case "Cystine":
        case "Tyrosine":
        case "Histidine": // Essential Amino Acids below here
        case "Isoleucine":
        case "Leucine":
        case "Methionine":
        case "Phenylalanine":
        case "Threonine":
        case "Tryptophan":
        case "Valine":
        case "Lysine":
            return nutrientName;
        // Minerals
        case "Calcium, Ca":
            return "Calcium";
        case "Iron, Fe":
            return "Iron";
        case "Magnesium, Mg":
            return "Magnesium";
        case "Phosphorus, P":
            return "Phosphorus";
        case "Potassium, K":
            return "Potassium";
        case "Sodium, Na":
            return "Sodium";
        case "Zinc, Zn":
            return "Zinc";
        case "Copper, Cu":
            return "Copper";
        case "Manganese, Mn":
            return "Manganese";
        case "Selenium, Se":
            return "Selenium";
        // Vitamins
        case "Vitamin A, RAE":
            return "Vitamin A";
        case "Vitamin E (alpha-tocopherol)":
            return "Vitamin E";
        case "Vitamin D (D2 + D3), International Units":
            return "Vitamin D";
        case "Vitamin C, total ascorbic acid":
            return "Vitamin C";
        case "Thiamin":
            return "Thiamin";
        case "Riboflavin":
            return "Riboflavin";
        case "Niacin":
            return "Niacin";
        case "Vitamin B-6":
            return "Vitamin B6";
        case "Vitamin B-12":
            return "Vitamin B12";
        case "Choline, total":
            return "Choline";
        case "Vitamin K (phylloquinone)":
            return "Vitamin K";
        case "Folate, DFE":
            return "Folate";
        // Other
        case "Pantothenic acid":
            return "Pantothenic Acid";
        case "Biotin":
            return "Biotin";
        case "Alcohol, ethyl":
            return "Alcohol";
        case "Caffeine":
            return "Caffeine";
        case "Water":
            return "Water";
        default:
            return null;
    }
};
const lipidsForCategorizing = [
    "Total lipid (fat)",
    "Total fat (NLEA)",
    "Cholesterol",
    "Fatty acids, total trans",
    "Fatty acids, total saturated",
    "Fatty acids, total monounsaturated",
    "Fatty acids, total polyunsaturated",
    "Fatty acids, total trans-monoenoic",
    "Fatty acids, total trans-dienoic",
    "Fatty acids, total trans-polyenoic",
    "Linoleic Acid",
    "10:0",
    "11:0",
    "12:0",
    "12:1",
    "13:0",
    "14:0",
    "14:1",
    "14:1 c",
    "14:1 t",
    "15:0",
    "15:1",
    "16:0",
    "16:1",
    "16:1 c",
    "16:1 t",
    "17:0",
    "17:1",
    "17:1 c",
    "18:0",
    "18:1",
    "18:1 c",
    "18:1 t",
    "18:1-11 t (18:1t n-7)",
    "18:2",
    "18:2 CLAs",
    "18:2 c",
    "18:2 i",
    "18:2 n-6 c,c",
    "18:2 t not further defined",
    "18:2 t,t",
    "18:3",
    "18:3 c",
    "18:3 n-3 c,c,c (ALA)",
    "18:3 n-6 c,c,c",
    "18:3 t",
    "18:3i",
    "18:4",
    "20:0",
    "20:1",
    "20:1 c",
    "20:1 t",
    "20:2 c",
    "20:2 n-6 c,c",
    "20:3",
    "20:3 c",
    "20:3 n-3",
    "20:3 n-6",
    "20:3 n-9",
    "20:4",
    "20:4 c",
    "20:4 n-6",
    "20:5 c",
    "20:5 n-3 (EPA)",
    "21:0",
    "21:5",
    "22:0",
    "22:1",
    "22:1 c",
    "22:1 n-11",
    "22:1 n-9",
    "22:1 t",
    "22:2",
    "22:3",
    "22:4",
    "22:5 c",
    "22:5 n-3 (DPA)",
    "22:6 c",
    "22:6 n-3 (DHA)",
    "23:0",
    "24:0",
    "24:1 c",
    "Stigmasterol",
    "Campesterol",
    "Brassicasterol",
    "Beta-sitosterol",
    "Campestanol",
    "Beta-sitostanol",
    "Delta-5-avenasterol",
    "Phytosterols",
    "Phytosterols, other",
];
const mineralsForCategorizing = [
    "Boron, B",
    "Calcium, Ca",
    "Chlorine, Cl",
    "Chromium, Cr",
    "Cobalt, Co",
    "Copper, Cu",
    "Fluoride, F",
    "Iodine, I",
    "Iron, Fe",
    "Magnesium, Mg",
    "Manganese, Mn",
    "Molybdenum, Mo",
    "Nickel, Ni",
    "Phosphorus, P",
    "Potassium, K",
    "Selenium, Se",
    "Sodium, Na",
    "Sulfur, S",
    "Zinc, Zn",
];
const carbsForCategorizing = [
    "Carbohydrate, by difference",
    "Carbohydrate, by summation",
    "Carbohydrate, other",
    "Starch",
    "Sucrose",
    "Glucose (dextrose)",
    "Fructose",
    "Lactose",
    "Maltose",
    "Galactose",
    "Xylitol",
    "Sorbitol",
    "Sugars, Total NLEA",
    "Sugars, added",
    "Sugars, total including NLEA",
    "Total sugar alcohols",
    "Fiber, total dietary",
    "Fiber, soluble",
    "Fiber, insoluble",
    "Ribose",
    "Inulin",
    "Inositol",
];
const proteinsForCategorizing = [
    "Protein",
    "Histidine",
    "Isoleucine",
    "Leucine",
    "Lysine",
    "Methionine",
    "Phenylalanine",
    "Threonine",
    "Tryptophan",
    "Valine",
    "Alanine",
    "Arginine",
    "Aspartic acid",
    "Cysteine",
    "Cystine",
    "Glutamic acid",
    "Glutamine",
    "Glycine",
    "Proline",
    "Serine",
    "Hydroxyproline",
    "Tyrosine",
];
const vitaminsForCategorizing = [
    "10-Formyl folic acid (10HCOFA)",
    "25-hydroxycholecalciferol",
    "5-Formyltetrahydrofolic acid (5-HCOH4)",
    "5-methyl tetrahydrofolate (5-MTHF)",
    "Biotin",
    "Epigallocatechin-3-gallate",
    "Folate, DFE",
    "Folate, food",
    "Folate, total",
    "Folic acid",
    "Niacin",
    "Pantothenic acid",
    "Retinol",
    "Riboflavin",
    "Tocopherol, beta",
    "Tocopherol, delta",
    "Tocopherol, gamma",
    "Tocotrienol, alpha",
    "Tocotrienol, beta",
    "Tocotrienol, delta",
    "Tocotrienol, gamma",
    "Vitamin A, IU",
    "Vitamin A, RAE",
    "Vitamin B-12",
    "Vitamin B-12, added",
    "Vitamin B-6",
    "Vitamin C, total ascorbic acid",
    "Vitamin D (D2 + D3)",
    "Vitamin D (D2 + D3), International Units",
    "Vitamin D2 (ergocalciferol)",
    "Vitamin D3 (cholecalciferol)",
    "Vitamin E",
    "Vitamin E (alpha-tocopherol)",
    "Vitamin E (label entry primarily)",
    "Vitamin E, added",
    "Vitamin K (Dihydrophylloquinone)",
    "Vitamin K (Menaquinone-4)",
    "Vitamin K (phylloquinone)",
    "Choline, total",
    "Choline, free",
    "Choline, from phosphocholine",
    "Choline, from phosphotidyl choline",
    "Choline, from glycerophosphocholine",
    "Choline, from sphingomyelin",
    "Thiamin",
];
const phytonutrientsForCategorizing = [
    "Carotene, alpha",
    "Carotene, beta",
    "Cryptoxanthin, alpha",
    "Cryptoxanthin, beta",
    "Lutein",
    "Lutein + zeaxanthin",
    "Lycopene",
    "Zeaxanthin",
    "cis-Lutein/Zeaxanthin",
    "cis-Lycopene",
    "cis-beta-Carotene",
    "trans-Lycopene",
    "trans-beta-Carotene",
    "Phytoene",
    "Phytofluene",
];
const othersForCategorizing = [
    "Nitrogen",
    "Ash",
    "Energy",
    "Alcohol, ethyl",
    "Specific Gravity",
    "Acetic acid",
    "Lactic acid",
    "Water",
    "Caffeine",
    "Theobromine",
    "Betaine",
    "Taurine",
];
const nutrientCategoryMapping = {
    Lipid: lipidsForCategorizing,
    Mineral: mineralsForCategorizing,
    Carbohydrate: carbsForCategorizing,
    Protein: proteinsForCategorizing,
    Vitamin: vitaminsForCategorizing,
    Phytonutrient: phytonutrientsForCategorizing,
    Other: othersForCategorizing,
};
export const getCategoryFromName = (nutrientName) => {
    for (const [category, nutrients] of Object.entries(nutrientCategoryMapping)) {
        if (nutrients.includes(nutrientName)) {
            return category;
        }
    }
    return "Other";
};
//# sourceMappingURL=nutrient-utils.js.map